import { render, staticRenderFns } from "./JuradoUserForm.vue?vue&type=template&id=4f60c85b"
import script from "./JuradoUserForm.vue?vue&type=script&lang=js"
export * from "./JuradoUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports